export class MvError extends Error {
  constructor() {
    super('Erro na integração com o MV.')
    this.name = 'MvError'
  }
}
